import { useMemo } from "react";
import { useFetchPutV2 } from "hooks/fetch/useFetchPutV2";

export function usePutRule(ruleId) {
  const url = useMemo(() => `rules/${ruleId}`, [ruleId]);
  const { loading, error, putCallback } = useFetchPutV2(url);

  return { loading, error, putRuleCallback: putCallback };
}
